<template>
  <Teleport to="body">
    <Transition name="skb" mode="out-in">
      <div class="serial-keyboard-background" v-show="keyboard.isOpen">
        <div
          ref="serialKeyboardContainerRef"
          class="serial-keyboard-container"
          v-on-click-outside="[onClickOutside, { ignore: ['.serial-input-item'] }]"
        >
          <div @click="keyboard.close()" class="cmd-key">
            <i class="icon-keyboard"></i><i class="icon-arrow-down"></i>
          </div>
          <div></div>
          <div></div>
          <div @click="backspace()" class="cmd-key"><i class="icon-delete"></i></div>
          <div @click="onKey('7')" class="key">7</div>
          <div @click="onKey('8')" class="key">8</div>
          <div @click="onKey('9')" class="key">9</div>
          <div @click="onKey('F')" class="key">F</div>
          <div @click="onKey('4')" class="key">4</div>
          <div @click="onKey('5')" class="key">5</div>
          <div @click="onKey('6')" class="key">6</div>
          <div @click="onKey('E')" class="key">E</div>
          <div @click="onKey('1')" class="key">1</div>
          <div @click="onKey('2')" class="key">2</div>
          <div @click="onKey('3')" class="key">3</div>
          <div @click="onKey('D')" class="key">D</div>
          <div @click="onKey('0')" class="key">0</div>
          <div @click="onKey('A')" class="key">A</div>
          <div @click="onKey('B')" class="key">B</div>
          <div @click="onKey('C')" class="key">C</div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useSerialKeyboard } from '@/stores/serial-keyboard.store';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { vOnClickOutside } from '@vueuse/components';
import { useElementBounding } from '@vueuse/core';
import { ref, watch } from 'vue';

const keyboard = useSerialKeyboard();
const serialKeyboardContainerRef = ref<HTMLDivElement>();
const { height } = useElementBounding(serialKeyboardContainerRef);

function onKey(key: string) {
  Haptics.impact({ style: ImpactStyle.Light }).catch((e) => console.log(e));
  keyboard.keyPressed(key);
}

function backspace() {
  Haptics.impact({ style: ImpactStyle.Light }).catch((e) => console.log(e));
  keyboard.backspace();
}

function onClickOutside(ev: any) {
  if (keyboard.isOpen) {
    keyboard.close();
  }
}

watch(
  height,
  (keyboardHeight) => {
    const el = document.getElementById('ionApp');
    if (el && keyboardHeight) {
      el.style.height = `calc(100% - ${keyboardHeight}px)`;
    } else if (el) {
      el.style.height = '100%';
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.skb-enter-from,
.skb-leave-to {
  transform: translateY(100%);
}

.skb-enter-active,
.skb-leave-active {
  transition: transform 220ms ease-in-out;
}
.cmd-key {
  @apply flex justify-center items-center text-xl font-bold text-gray-700 active:text-gray-500 select-none;
}
.key {
  @apply flex justify-center items-center text-lg font-bold text-gray-700 bg-white active:bg-gray-50 rounded-lg select-none;
}
.serial-keyboard-container {
  @apply max-w-[500px] max-h-[40vh] aspect-[10/7] mx-auto bg-gray-100 grid grid-cols-4 grid-rows-5 gap-2 px-2 pb-12 overflow-hidden;
  box-shadow: 0px -2px 25px rgba(0, 0, 0, 0.15);
  z-index: 99999;
  border-radius: 15px;
}
.serial-keyboard-background {
  @apply fixed bottom-0 left-0 right-0 bg-white;
}
</style>
